import * as z from 'zod'

import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_wg_members = (params: StepConfigParams) =>
  ({
    schema: z.object({
      flatmates: BaseSchema_ContentsV1GetsafeDe.shape.flatmates.unwrap().nonempty(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.wg.members.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.wg.members.title',
        },
      },
      {
        type: 'editableSet',
        name: 'flatmates',
        addItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.wg.members.addMore',
        },
        removeItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.wg.members.remove',
        },
        configuration: {
          title: {
            type: 'translatableText',
            translationKey: 'sharedFlows_contents:steps.contents.wg.members.configTitle',
          },
          elements: [
            {
              type: 'input',
              name: 'first_name',
              label: {
                type: 'translatableText',
                translationKey:
                  'sharedFlows_contents:steps.contents.wg.members.elements.firstName.input.label',
              },
              styleType: 'outlined',
            },
            {
              type: 'input',
              name: 'last_name',
              label: {
                type: 'translatableText',
                translationKey:
                  'sharedFlows_contents:steps.contents.wg.members.elements.lastName.input.label',
              },
              styleType: 'outlined',
            },
          ],
        },
      },
    ],
    subFlow: params.subFlow,

    nextStep: 'postQuoteStep',
  }) as const satisfies AnyStepConfiguration

export default contents_wg_members
